import React, { useContext } from 'react';
import { useHistory } from 'react-router';

import { AuthContext } from '../providers/AuthProvider';
import { ConnectWallet } from './ConnectWallet';
import { NoWalletDetected } from './NoWalletDetected';

const Login = () => {
  const authCtxt = useContext(AuthContext);
  const history = useHistory();

  if (authCtxt.selectedAddress) {
    history.replace('/profile');
  }

  window.ethereum.on('accountsChanged', ([newAddress]) => {
    if (newAddress) {
      history.replace('/profile');
    }
  });

  if (!window.ethereum) {
    return <NoWalletDetected />;
  }

  return (
    <ConnectWallet
      connectWallet={() => authCtxt._connectWallet()}
      autoConnectWallet={() => authCtxt._autoConnectWallet()}
      networkName={authCtxt.networkName}
      networkError={authCtxt.networkError}
      dismiss={() => authCtxt._dismissNetworkError()}
    />
  );
};

export default Login;
